import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import {
	BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading';
import utils from '../../../../utils/validateScanner.js';

export default {
  name: 'DTOFlyer',
  mixins: [utils],
  components: {
    BasicSelect,
		VueElementLoading,
  },

  data: function() {
    return {
      shippingID: '',
      LoginHubId: '',
      isLoading: false,
      barCode:'',
      useremail :'',
      restrictiontype:'stickerprinting',
      shippingIDColor:"",
      Weighingrequired: null
    }
  },
  created: function() {},
	computed: {},
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
    this.useremail = userdetail[0].email;
		this.LoginHubId =userdetail[0].HubId[0];
    this.$refs.shippingID.focus();
    this.hubid = userdetail[0].HubId[0];
    this.hubForManualRestriction();
		
		this.$router.replace({ query: {} });
  },
  methods: {
    nextshippingID(){
      this.$nextTick(() => {
        this.$refs.barCode.focus();
      })
    },
    updatemackerchecker(){
      this.isLoading=true;
      this.input = ({
        FlyerBarcode:this.barCode,
        shippingId: this.shippingID,
        currentHubId: this.LoginHubId,
        lastModifiedBy : this.useremail
        })
         this.Weighingrequired = null
     axios({
         method: 'PUT',
         url: apiUrl.api_url_hubops + 'updatemakerchecker',
         'data': this.input,
         headers: {
           'authorization': 'authkey xB84JJ89Hd25',
         }
       })
       .then(async result => {
         this.isLoading=false;
         if (result.data.ResultCode == 100) {

          this.Weighingrequired = result.data.isReverseWeightCapturedCheck;
          
          if(Object.keys(result.data.lossCategorization).length !=0){
            this.shippingIDColor=this.shippingID;
            this.showHideCodeIconInput(result.data.lossCategorization.colorCode, result.data.lossCategorization.icon);
					}
           this.$alertify.success(result.data.ReturnMessage)
         } else {
           this.$alertify.error(result.data.ReturnMessage)
         }
         this.reset();
         this.$nextTick(() => {
           this.$refs.shippingID.focus();
         })
       }, error => {
         this.isLoading=false;
         console.error(error)
       })
   },
   onSubmit: function() {
     this.$validator.validateAll()
       .then((result) => {
         if (!result) {
           return false;
         } else {
           this.updatemackerchecker();
         }
       }).catch(() => {
         console.log('errors exist', this.errors);
       });
   },
    reset() {
      this.$validator.reset();
      this.shippingID = '';
      this.isLoading = false;
      this.barCode='';
    },

  }
}



// WEBPACK FOOTER //
// ./src/views/components/DTOstickering/DTOFlyer/DTOFlyer.js